export const PROFILE_USER_PAGE = '[CLOSE].userProfilePage';
export const AUTODESK_PAGE = '[CLOSE].autoDeskPage';
export const MARKET_PAGE = '[CLOSE].marketPage';
export const INTERACTIVE_PAGE = '[CLOSE].Interactive';
export const SETTING_PAGE = '[CLOSE].SettingPage';
export const SHOPPINGCART = '[CLOSE].ShoppingCartPage';
export const CATALOGUE = '[CLOST].CataloguePage';

// from other component
export const PRODUCT = '[CLOST].Product';
